import React from "react";
import "./SectionHeader.css";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  centered = true,
}) => {
  return (
    <div
      className="section-header"
      style={{ textAlign: centered ? "center" : "left" }}
    >
      <h1 dangerouslySetInnerHTML={{ __html: title }} />
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
};

export default SectionHeader;
